var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91888 10.6017L3.8624 6.55728C3.81425 6.50913 3.78006 6.45697 3.75984 6.4008C3.73962 6.34462 3.72967 6.28444 3.72999 6.22024C3.72999 6.15604 3.73994 6.09586 3.75984 6.03969C3.77974 5.98351 3.81393 5.93135 3.8624 5.8832L7.91888 1.82672C8.03122 1.71438 8.17165 1.6582 8.34017 1.6582C8.50869 1.6582 8.65314 1.71839 8.77351 1.83876C8.89388 1.95913 8.95406 2.09956 8.95406 2.26006C8.95406 2.42055 8.89388 2.56098 8.77351 2.68135L5.23462 6.22024L8.77351 9.75913C8.88585 9.87148 8.94203 10.01 8.94203 10.1746C8.94203 10.3393 8.88184 10.4817 8.76147 10.6017C8.6411 10.7221 8.50067 10.7823 8.34017 10.7823C8.17968 10.7823 8.03925 10.7221 7.91888 10.6017Z",
    fill: "#888070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.5069f6102cb87a030c31cca6fd6b12ef.svg";
export { ForwardRef as ReactComponent };